<template>
  <div class="listView">
    <P class="title bold">{{ list1.title }}</P>
    <div class="fw box fs-14">
      <p
        v-for="(item, ind) in list1.list"
        :key="ind"
        :class="item.isTrue === true ? 'active' : ''"
        @click="clicLisk(item)"
      >
        <span v-if="item.letter">{{ item.letter }}</span> {{ item.label==='专科'?'专科(高职)':item.label }}
      </p>
    </div>
  </div>
</template>
    
<script>
export default {
  name: "ListView",
  props: {
    list1: Object,
  },
  computed: {},

  watch: {},
  data() {
    return {
      activeIndex: 0,
    };
  },
  methods: {
    clicLisk(val) {
      this.$emit("list", val);
    },
  },
  mounted() {},
};
</script>
    

<style lang="scss" scoped>
.listView {
  margin-bottom: 10%;
  cursor: pointer;
  .title {
    border-left: 4px solid #1676ff;
    padding: 0 13px;
    margin: 5px 0 15px 0;
  }
  .box {
    p {
      min-width: 80px;
      max-width: 180px;
      padding: 5px;
      border: 1px solid #b4b4b4;
      margin-right: 2.5%;
      border-radius: 5px;
      margin-bottom: 3%;
      text-align: center;
    }
    .active {
      background: #1676ff;
      color: #fff;
      border: 1px solid #1676ff;
    }
  }
}
</style>
    